import "styles/components/character-app/_form.scss";
import useBEM from "hooks/useBEM";
import TextInput from "components/interface/TextInput";
import {Radio, RadioGroup} from "components/interface/Radio";
import {useCallback} from "react";
import {getCharacterDefaults, useCharacterParams} from "contexts/CharacterParams";
import CharacterTabsPanel from "components/CharacterApp/interface/CharacterTabs/CharacterTabsPanel";

export default function NameTab() {
  const classes = useBEM('character-tabs');
  const {parameters, setParameter} = useCharacterParams();
  const characterDefaults = getCharacterDefaults(parameters?.character);

  const handleRadios = useCallback((name) => {
    if (name) {
      return (value) => {
        setParameter(name, value);
      };
    }
  }, [setParameter]);

  const handleChange = useCallback((e) => {
    if (e?.target?.name) {
      setParameter(e.target.name, e.target.value);
    }
  }, [setParameter]);

  return <CharacterTabsPanel value={'name'}>
    <div className={classes('panel-inner')}>
      <h4 className={classes('panel-title')}>Name Your Little Hero!</h4>
      <div className={'form'}>
        <TextInput label={'Enter your superhero\'s name:'} placeholder={characterDefaults.name} name={'name'} pattern={'[A-Za-z ]'}
                   description={'Pick a fun hero name, please don’t use yours'}
                   value={parameters.name} onChange={handleChange} maxLength={16}/>

        <TextInput label={'Add your superhero\'s catch phrase:'} placeholder={characterDefaults.tagline} pattern={'[A-Za-z !,.]'}
                   name={'tagline'} value={parameters.tagline} onChange={handleChange} maxLength={80}/>

        <RadioGroup name={'flavour'} label={'Select your favourite Altrini flavour:'} defaultValue={'strawberry'}
                    value={parameters.flavour} onChange={handleRadios('flavour')}>
          <Radio label={'Super Strawberry'} value={'strawberry'}/>
          <Radio label={'Valiant Vanilla'} value={'vanilla'}/>
        </RadioGroup>
      </div>
    </div>
  </CharacterTabsPanel>
}
